module.exports = __webpack_public_path__ + "static/mara-b4a5c97f313ec97e603566f1d6bb11f1.jpeg";